import React, { createContext, useContext, useEffect, useState } from "react";
import { getAllFolder } from "../api/folderapi";

// Create the context
export const FileContext = createContext();

// Create the provider component
export const FileProvider = ({ children }) => {
  const [files, setFiles] = useState([]);

  const [viewType, setViewType] = useState("grid");
   const [search, setSearch] = useState("");
  const [sortOption, setSortOption] = useState("");
 const [selectedFile, setSelectedFile] = useState(null);
 /*  const [downloadProgress, setDownloadProgress] = useState(0);
   const [isDownload, setIsDownload] = useState(false); */
   const [progress, setProgress] = useState(0);
  const [isDownloading, setIsDownloading] = useState(false);


  
  return (
    <FileContext.Provider value={{ files, setFiles, viewType, setViewType, search,
        setSearch, sortOption,
        setSortOption, selectedFile,
      
       progress, setProgress,
  isDownloading, setIsDownloading,
   isDownloading, progress,
        setSelectedFile}}>
      {children}
    </FileContext.Provider>
  );
};

const useFiles = ()=>{
  return useContext(FileContext)
} 

export default useFiles; 